'use es6';

export var MEDIA_ALIGNMENT_TYPES = {
  start: 'private-media--align-start',
  baseline: 'private-media--align-baseline',
  center: 'private-media--align-middle',
  end: 'private-media--align-bottom',
  stretch: 'private-media--align-stretch'
};
export var MEDIA_SPACING = {
  none: 'private-media--collapsed',
  'extra-small': 'private-media--spaced-xs',
  small: '',
  medium: 'private-media--spaced-md',
  large: 'private-media--spaced-lg',
  'extra-large': 'private-media--spaced-xl'
};